import React from 'react';
import ScrollableAnchor from 'react-scrollable-anchor';

const Section=(props)=>(
    <ScrollableAnchor id={props.id}>
         {props.children}
    </ScrollableAnchor>
);

export default Section;